import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { firebaseReducer } from '../data/auth';

export default combineReducers({
  routing: routerReducer,
  firebase: firebaseReducer
});



// WEBPACK FOOTER //
// ./src/store/reducers.js